import StaffEmployeeLink from "./StaffEmployeeOverlay";
import { step11Text } from "./staff-step11-language";
import { useStaff, type StaffBootstrap } from "@/hooks/use-staff";

export function staffPickerMaskedId(id:string,data:Pick<StaffBootstrap,"employees">|undefined,rtl:boolean){
  // Display only the last four digits already available to this signed-in user.
  // This lookup never expands the picker list or grants selection/payment access.
  const suffix=data?.employees.find(p=>p.id===id)?.nationalId?.slice(-4);
  return suffix&&/^\d{4}$/.test(suffix)?step11Text(`ID ••${suffix}`,rtl):"";
}

export default function StaffPickerEmployeeRow({id,name,metadata,branch,showBranch=true,rtl,onSelect}:{id:string;name:string;metadata:string;branch:string;showBranch?:boolean;rtl:boolean;onSelect:()=>void}){
  const staff=useStaff(),masked=staffPickerMaskedId(id,staff.isError?undefined:staff.data,rtl),branchSuffix=` · ${branch}`;
  const displayMetadata=masked?(metadata.endsWith(branchSuffix)?`${metadata.slice(0,-branchSuffix.length)} · ${masked}${branchSuffix}`:`${metadata} · ${masked}`):metadata;
  // Sibling controls preserve card access without nesting an interactive link/button
  // in the prototype's full-width employee-selection button.
  return <div className="employee-picker-row prototype-picker-row">
    <button type="button" className="opt" aria-label={`${step11Text("Select",rtl)} ${name}`} onClick={onSelect}><span><b className="picker-name-spacer" aria-hidden="true">{name}</b><small>{displayMetadata}</small></span>{showBranch&&<span className="pill act">{branch}</span>}</button>
    <StaffEmployeeLink employeeId={id} className="picker-person-name" label={name}><b>{name}</b></StaffEmployeeLink>
  </div>;
}
